 
import { SharedAppConstants } from '@tock/shared-app-constants';
import { core } from '@tock/coretypes';
import protos from 'utils/protos';

const { AnsweredPurchaseQuestions } = protos;

export function answerQuestionResponses(
  purchaseId: number,
  question: core.IPurchaseQuestion[]
): ApiAction {
  const request = AnsweredPurchaseQuestions.fromObject({
    purchaseId,
    question,
  });
  return {
    TockApi: {
      postProto: '/admin/purchase/question/answer',
      request,
      type: SharedAppConstants.QUESTION_RESPONSE_UPDATE,
    },
  };
}

export function editQuestionResponses(
  purchaseId: number,
  question: core.IPurchaseQuestion[]
): ApiAction {
  const request = AnsweredPurchaseQuestions.fromObject({
    purchaseId,
    question,
  });
  return {
    TockApi: {
      postProto: '/admin/purchase/question/update',
      request,
      type: SharedAppConstants.QUESTION_RESPONSE_UPDATE,
    },
  };
}
